var modalArretado = (function () {
var iframeTorado = $('#modalVideo').find('.video-home').html();

$('#modalVideo').on('hide.bs.modal', function(){
	console.log(iframeTorado);
		$(this).find('iframe').remove();
		$(this).find('.video-home').append(iframeTorado);
	});

})();